import React, { Component } from 'react';
import qs from 'qs';
import ReactGA from 'react-ga';
import SearchResults from '../../components/search-results';
import {
  search,
  trackClick,
  spellingSuggestion,
  createTracker,
  trackPageView,
} from '../../utils/interface';
import {
  addFilter,
  delFilter,
  getFilters,
  isFacetSelected,
  getPage,
  changePage,
  changeSort,
  getSort,
  setAnalyticsTags,
} from '../../utils';
import { facets, result_fields, search_fields } from '../../utils/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class SearchResultsContainer extends Component {
  docType = this.props.app === 'ELSS' ? 'page' : 'page';

  state = {
    showResponsiveMenu: false,
    isLoading: true,
    hasError: false,
    results: {
      meta: {
        alerts: [],
        warnings: [],
        request_id: '',
        precision: null,
        page: {
          total_pages: null,
          size: null,
          current: null,
          results_count: null,
        },
      },
    },
    spelling: { text: '', offset: null, length: null, options: [] },
  };

  constructor(props) {
    super(props);
    createTracker;
    if (props.ga) {
      this.ReactGA = ReactGA;
      ReactGA.initialize(props.ga, { debug: props.gaDebug });
    }
    trackPageView();
  }

  addAnalytics = (q) => {
    if (this.ReactGA) {
      if (q) {
        this.ReactGA.pageview(`/?stq=${q}`);
      } else {
        this.ReactGA.pageview();
      }
    }
  };

  getQ = () => {
    const hash = window.location.search;
    const { q } = qs.parse(hash.indexOf('?') === 0 ? hash.substr(1) : hash);
    return decodeURIComponent(q || '');
  };

  search = (q) => {
    const { href } = window.location;
    const searchQ = href.substring(href.indexOf('?'));
    this.addAnalytics(q);
    const canSearch = this.getQ();
    const query = decodeURIComponent(q || '');
    canSearch &&
      search({
        page: {
          size: 10,
          current: parseInt(getPage(searchQ)),
        },
        query: query,
        result_fields,
        search_fields,
        facets,
        sort: {
          [getSort(searchQ).sort_field]: getSort(searchQ).sort_direction,
        },
        filters: getFilters(searchQ),
        analytics: setAnalyticsTags(searchQ),
      })
        .then((results) => {
          if (!Object.keys(results).includes('results')) {
            this.setState({ hasError: true });
          } else {
            this.setState({ isLoading: false });
            this.setState({
              ...this.state,
              results,
            });
          }
        })
        .catch(() => {
          this.setState({ isLoading: false });
          this.setState({ hasError: true });
        });

    canSearch &&
      spellingSuggestion(query).then((results) => {
        if (
          Array.isArray(results) &&
          results.length === 1 &&
          Object.keys(results[0]).includes('options')
        ) {
          this.setState({ spelling: results[0] });
        }
      });
  };

  addFacet = (cat, value) => () => {
    const push = this.push;
    const { q } = this.getParams();
    const { search } = window.location;
    const filters = addFilter(cat, value, search);
    if (search === `?${filters}`) return;
    push({
      pathname: q,
      search: `${filters}`,
    });
  };

  delFacet = (cat, value) => () => {
    const push = this.push;
    const { q } = this.getParams();
    const { search } = window.location;
    const filters = delFilter(cat, value, search);
    if (search === `?${filters}`) return;
    push({
      pathname: q,
      search: `${filters}`,
    });
  };

  isFacetActive = (cat, value) => {
    const location = window.location;
    return isFacetSelected(cat, value, location.search);
  };

  oldUrlParams = '';

  getParams = () => {
    const hash = window.location.search;
    return qs.parse(hash.indexOf('?') === 0 ? hash.substr(1) : hash);
  };

  checkUrlParams = () => {
    const params = this.getParams();
    const { q } = params;
    const newParams = qs.stringify(params);
    if (newParams !== this.oldUrlParams) {
      this.oldUrlParams = newParams;
      this.search(q);
    }
  };

  push = ({ pathname, search }) => {
    const params = {
      q: pathname,
      ...qs.parse(search),
    };
    window.location = `${window.location.origin}${window.location.pathname.replace(
      /\/\s*$/,
      '',
    )}?${qs.stringify(params)}`;
  };

  goToPage = (p) => {
    const push = this.push;
    const { q } = this.getParams();
    const { search } = window.location;
    const newSearch = changePage(search, p);
    if (search === `?${newSearch}`) return;
    push({
      pathname: q,
      search: newSearch,
    });
  };

  changeSort = (field, direction) => {
    const push = this.push;
    const { q } = this.getParams();
    const { search } = window.location;
    const newSearch = changeSort(field, direction, search);
    if (search === `?${newSearch}`) return;
    push({
      pathname: q,
      search: newSearch,
    });
  };

  resetFilters = () => {
    const push = this.push;
    const { q } = this.getParams();
    push({
      pathname: q,
    });
  };

  tClick = (q, docId, request_id, site, url, results, title) => {
    trackClick(q, docId, request_id, site, url, results, title);
  };

  render() {
    this.checkUrlParams(this.props);
    const { q } = this.getParams();
    return this.state.isLoading ? (
      <div className='loading'>
        <FontAwesomeIcon icon='spinner' className={`spinner ${this.props.app}`} />
      </div>
    ) : this.state.hasError ? (
      <div className='error'>
        <FontAwesomeIcon icon='bell' color='#b41f28' />
        <div>
          <h2>Error:</h2>
          <p>{this.state.results.errors}</p>
        </div>
      </div>
    ) : (
      <SearchResults
        app={this.props.app}
        tClick={this.tClick}
        results={this.state.results}
        q={q}
        push={this.push}
        addFacet={this.addFacet}
        delFacet={this.delFacet}
        isFacetActive={this.isFacetActive}
        goToPage={this.goToPage}
        changeSort={this.changeSort}
        sortField={this.getParams().sort_field}
        showResponsiveMenu={this.state.showResponsiveMenu}
        toggleResponsiveMenu={this.toggleResponsiveMenu}
        resetFilters={this.resetFilters}
        spelling={this.state.spelling}
      />
    );
  }
}

export default SearchResultsContainer;
